module.exports = __webpack_public_path__ + "static/media/blankEmail.48542be2.svg";